export default {
  id: null,
  companyID: null,
  tablename: null,
  actionid: null,
  actiondate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/administrativelogmodel.js